// The task PATCH (taskApi.saveManageTask) replaces every one of these, and one left out comes back empty: a description
// left out was erased by every Task List edit (seen on production, 2026-10-22).
const PATCH_FIELDS = ['title', 'details', 'dueDate', 'daysToStartAhead', 'duration', 'priority', 'timeNeed'] as const;

/**
 * A task to save from: what the PATCH takes is the server's, as just read, so nothing is blanked (the Task List's copy has
 * no description) and nothing stale goes back - the change goes on top of it.
 */
export const withServerFields = <T extends Record<string, any>>(task: T, server: Record<string, any>): T => {
  const merged: Record<string, any> = { ...task };
  PATCH_FIELDS.forEach(field => {
    if (server[field] !== undefined) merged[field] = server[field];
  });
  return merged as T;
};

// What the Task List shows of the fields a save changes: shown at once on the request, put back if the save fails.
const LIST_FIELDS = ['title', 'dueDate', 'daysToStartAhead', 'duration', 'priority', 'timeNeed'] as const;

/** Of `source`, the list's fields among those `changed` has (all of them without `changed`). */
export const listFields = (source: Record<string, any>, changed: Record<string, any> = source) => {
  const fields: Record<string, any> = {};
  LIST_FIELDS.forEach(field => {
    if (field in changed && changed[field] !== undefined) fields[field] = source[field];
  });
  return fields;
};
